import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import Tabs from './ui/react-ui/tabs';
import DataTable from './ui/table';
import SearchBar from './ui/searchBar'; // api

import { getDriverList, getVehicleList } from '../api/freightAPI'; // redux

import { setDriverList, setDriverSort, setVehicleList, setVehicleSort, reset } from '../redux/logistic-driver';
var t = i18n.getFixedT(null, 'logistic-driver');

var LogisticDriver = function LogisticDriver(props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$logistic = _useSelector.logisticDriver,
      driverList = _useSelector$logistic.driverList,
      driverSort = _useSelector$logistic.driverSort,
      vehicleList = _useSelector$logistic.vehicleList,
      vehicleSort = _useSelector$logistic.vehicleSort;

  var dispatch = useDispatch();
  var id = props.id;

  var _useState = useState('driver'),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalCount = _useState4[0],
      setTotalCount = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      keyword = _useState10[0],
      setKeyword = _useState10[1];

  var _isMounted = useRef(false);

  var _isResetUseState = useRef(false);

  var tabsMenu = [{
    key: 'driver',
    title: t('lbl-driver')
  }, {
    key: 'vehicle',
    title: t('lbl-vehicle')
  }];

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleSort = function handleSort(sort) {
    if (currentTab === 'driver') dispatch(setDriverSort(sort));else dispatch(setVehicleSort(sort));
  };

  var handleGetData = function handleGetData() {
    var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _currentPage, _rowsPerPage, _keyword;

    _currentPage = isInit ? 0 : currentPage;
    _rowsPerPage = isInit ? 10 : rowsPerPage;
    _keyword = isInit ? '' : keyword;

    var offset = (Number(_currentPage + 1) - 1) * _rowsPerPage;

    if (currentTab === 'driver') {
      return getDriverList(contextRoot, false, driverSort, offset, _rowsPerPage, _keyword).then(function (result) {
        var dList = _.map(result.content, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: offset + index + 1
          });
        });

        dispatch(setDriverList(dList));
        setTotalCount(result.totalElements);
      });
    } else {
      return getVehicleList(contextRoot, false, vehicleSort, offset, _rowsPerPage, _keyword).then(function (result) {
        var vList = _.map(result.content, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: offset + index + 1
          });
        });

        dispatch(setVehicleList(vList));
        setTotalCount(result.totalElements);
      });
    }
  };

  useEffect(function () {
    if (!_isMounted.current) return;
    if (!_isResetUseState.current) handleGetData();
    _isResetUseState.current = false;
  }, [JSON.stringify(driverSort), JSON.stringify(vehicleSort), keyword, currentPage, rowsPerPage]);
  useEffect(function () {
    if (!_isMounted.current) return;
    if (currentPage !== 0 || keyword !== '' || rowsPerPage !== 10) _isResetUseState.current = true;
    setCurrentPage(0);
    setKeyword('');
    setRowsPerPage(10);
    handleGetData(true);
  }, [currentTab]);
  useEffect(function () {
    if (!_isMounted.current) {
      handleGetData();
      _isMounted.current = true;
    }

    return function () {
      dispatch(reset());
    };
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  if (currentTab === 'driver') {
    _.set(fields, 'id', {
      label: t('lbl-driver-identity'),
      sortable: true
    });

    _.set(fields, 'name', {
      label: t('lbl-driver-name'),
      sortable: true
    });

    _.set(fields, 'logisticName', {
      label: t('lbl-logistic-name'),
      sortable: true
    });

    _.set(fields, 'logisticId', {
      label: t('lbl-tax-id-number'),
      sortable: true
    });

    _.set(fields, 'validFrom', {
      label: t('lbl-valid-from'),
      sortable: true
    });

    _.set(fields, 'validDate', {
      label: t('lbl-valid-date'),
      sortable: true
    });

    _.set(fields, 'modifiedAt', {
      label: t('lbl-update-time'),
      sortable: true
    });
  } else {
    _.set(fields, 'id', {
      label: t('lbl-license-identity'),
      sortable: true
    });

    _.set(fields, 'plateNo', {
      label: t('lbl-license-plate-number'),
      sortable: true
    });

    _.set(fields, 'logisticName', {
      label: t('lbl-logistic-name'),
      sortable: true
    });

    _.set(fields, 'logisticId', {
      label: t('lbl-trader-tax-id-number'),
      sortable: true
    });

    _.set(fields, 'vehicleType', {
      label: t('lbl-car-type'),
      sortable: true
    });

    _.set(fields, 'validFrom', {
      label: t('lbl-valid-from'),
      sortable: true
    });

    _.set(fields, 'validDate', {
      label: t('lbl-valid-date'),
      sortable: true
    });

    _.set(fields, 'modifiedAt', {
      label: t('lbl-update-time'),
      sortable: true
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "logisticDriver-headBar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(search) {
      setKeyword(search); // if(_.isEmpty(search))
      //     handleGetData()
    },
    value: keyword
  })), /*#__PURE__*/React.createElement(Tabs, {
    id: "g-logistic-driver-tabs",
    menu: tabsMenu,
    current: currentTab,
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt content"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: currentTab === 'driver' ? driverList : vehicleList,
    sort: currentTab === 'driver' ? driverSort : vehicleSort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })));
};

LogisticDriver.defaultProps = {
  id: 'g-logistic-driver'
};
LogisticDriver.PropTypes = {
  id: PropTypes.string
};
export default LogisticDriver;